import { render } from "./ClanPedidos.vue?vue&type=template&id=66bd5cf8&scoped=true"
import script from "./ClanPedidos.vue?vue&type=script&lang=js"
export * from "./ClanPedidos.vue?vue&type=script&lang=js"

import "./ClanPedidos.vue?vue&type=style&index=0&id=66bd5cf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bd5cf8"]])

export default __exports__